import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
class Portal extends React.Component {
  componentDidMount () {
    this.el = document.querySelector('#portal-zone')
    this.forceUpdate()
  }

  render () {
    const { children, style } = this.props
    if (!this.el) return null
    return ReactDOM.createPortal((
      <div style={style}>
        {children}
      </div>
    ), this.el)
  }
}

Portal.propTypes = {
  children: PropTypes.any
}

export default Portal
